module.exports = __webpack_public_path__ + "img/img49.5db3f121.jpg";